import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { delay, Subject } from 'rxjs';
import { InfoOption } from '../../components/info/info.component';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { ValidationErrors } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'other-info-form',
    templateUrl: './other-info-form.component.html',
    styleUrls: ['./other-info-form.component.scss'],
    standalone: false
})
export class OtherInfoFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  subscriptions: any[] = [];
  countries: any[];
  departments: any[];
  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;
  error: ValidationErrors = null;
  optionInfo: InfoOption = {
    icon: 'info',
    backgroundColor: 'var(--info-neutral-bg-color)',
    iconColor: 'var(--info-neutral-font-color)',
    textColor: 'var(--info-neutral-font-color)',
    textDecoration: 'underline',
    margin: '0',
  };

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    let enabledUsPerson = true;
    this.subscriptionFacade.getPledge()?.products?.map(product => {
      if (product?.parameters?.enabledUsPerson == false) {
        enabledUsPerson = false;
      }
    });

    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe(data => {
      data.owners.map((owner, index) => {
        if (!enabledUsPerson && (owner.userUsCitizen || owner.userUsResident)) {
          this.owners.get(`${index}`).setErrors({
            incorrect: true,
            message:
              "La souscription n'est pas disponible pour les citoyens et les résidents américain.",
          });
        } else {
          this.owners.get(`${index}`).setErrors(null);
        }

        this.error = this.owners.get(`${index}`).errors;
      });
    });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
